import { gql } from '../../../../../types/__codegen__/sanity';

export const GET_HOME_PERK = gql(`
  query getMemberPerk($id: String) {
    allMemberPerk(where: { identifier: { current: { eq: $id } } }) {
      descriptionTeaser
      _id
      id: _id
      imageObject {
        ...ImageObjectFields
      }
      name
      release {
        ...ReleaseFields
      }
      slogan
      identifier {
        ...SlugFields
      }
      urlObject {
        ...UrlObjectFields
      }
    }
  }
`);
